module.exports = __webpack_public_path__ + "img/illu-eucalyptus.fa6ae1f6.svg";